export default __webpack_public_path__ + "static/media/furniture.0925bd3c.jpg";